import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X, Trash2, AlertTriangle } from "lucide-react";

interface DeleteTopicModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  topicTitle: string;
  onConfirm: () => void;
  isLoading?: boolean;
}

export const DeleteTopicModal = ({
  open,
  onOpenChange,
  topicTitle,
  onConfirm,
  isLoading = false
}: DeleteTopicModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md p-3 rounded-2xl" hideCloseButton={true}>
        <DialogHeader className="flex flex-row items-center justify-between pb-0">
          <DialogTitle className="text-lg font-medium text-gray-900">
            Delete topic
          </DialogTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleCancel}
            className="h-6 w-6 p-0 hover:bg-gray-100 rounded-full"
          >
            <X className="h-4 w-4" />
          </Button>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="space-y-2">
            <p className="text-sm text-gray-600">
              Are you sure you want to delete "<span className="font-medium">{topicTitle}</span>"?
            </p>
            <p className="text-sm text-gray-500">
              This will permanently remove the topic and all its content.
            </p>
          </div>
          
          <div className="flex justify-end gap-3">
            <Button
              variant="outline"
              onClick={handleCancel}
              disabled={isLoading}
              size="sm"
              className="rounded-2xl"
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirm}
              disabled={isLoading}
              size="sm"
              className="bg-red-600 hover:bg-red-700 text-white rounded-2xl"
            >
              {isLoading ? (
                <>
                  <Trash2 className="h-4 w-4 mr-2 animate-spin" />
                  Deleting...
                </>
              ) : (
                <>
                  <Trash2 className="h-4 w-4 mr-2" />
                  Delete
                </>
              )}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};